export const name = '@bigmi/client'
export const version = '0.10.1'
